import * as React from 'react';
export const zipSvg = React.forwardRef(function zipSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.936 10.206 2.3 13H15l-.418-3.198h-5.92l-.054-.399 5.456-3.6L13.7 3H1l.414 3.202h5.932L7.4 6.6l-5.464 3.605Z',
    }),
  );
});
zipSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var zip = {
  category: 'paymentmethod',
  colorable: true,
  name: 'zip',
  svg: zipSvg,
};
